(function () {
  'use strict';

  function money(cents) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format((Number(cents) || 0) / 100);
  }

  function waitForShopflo(timeout) {
    return new Promise(function (resolve) {
      var elapsed = 0;
      var timer = window.setInterval(function () {
        if (typeof window.handleFloCartBtn === 'function') {
          window.clearInterval(timer);
          resolve(true);
          return;
        }
        elapsed += 100;
        if (elapsed >= timeout) {
          window.clearInterval(timer);
          resolve(false);
        }
      }, 100);
    });
  }

  function openShopflo() {
    return waitForShopflo(5000).then(function (ready) {
      if (ready) {
        window.handleFloCartBtn();
        return;
      }
      window.location.href = '/cart';
    });
  }

  function postItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          throw new Error(body.description || body.message || 'Could not add this offer to cart.');
        });
      }
      return response.json();
    });
  }

  function fetchCart() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not read your cart. Please try again.');
      return response.json();
    });
  }

  function removeBundleFromCart(bundleId) {
    if (!bundleId) return Promise.resolve();

    return fetchCart().then(function (cart) {
      var updates = {};
      (cart.items || []).forEach(function (item) {
        var properties = item.properties || {};
        if (properties['_Fitty bundle'] === bundleId) updates[item.key] = 0;
      });

      if (!Object.keys(updates).length) return cart;

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (response) {
        if (!response.ok) throw new Error('Could not update this bundle in your cart.');
        return response.json();
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.fdhInit === 'true') return;
    root.dataset.fdhInit = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-fdh-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-fdh-panel]'));
    var modal = root.querySelector('[data-fdh-modal]');
    var modalTitle = root.querySelector('[data-fdh-modal-title]');
    var modalMedia = root.querySelector('[data-fdh-modal-media]');
    var toast = root.querySelector('[data-fdh-toast]');
    var toastTimer;
    var maxSameProduct = Math.max(1, Number(root.dataset.maxSameProduct) || 1);
    var states = {
      any3: { items: [], submitted: false, pending: false, bundleId: null },
      b2g2: { items: [], submitted: false, pending: false, bundleId: null }
    };
    var builderHostId = (root.id || ('fdh-' + Math.random().toString(36).slice(2))) + '-builder-host';
    var builderHost = document.getElementById(builderHostId);

    if (!builderHost) {
      builderHost = document.createElement('div');
      builderHost.id = builderHostId;
      builderHost.className = 'fdh-builder-host';
      if (root.classList.contains('fdh--freedom')) builderHost.classList.add('fdh--freedom');
      document.body.appendChild(builderHost);
    }

    ['--fdh-green', '--fdh-deep-green', '--fdh-lime', '--fdh-cream', '--fdh-white'].forEach(function (property) {
      var value = window.getComputedStyle(root).getPropertyValue(property).trim();
      if (value) builderHost.style.setProperty(property, value);
    });
    root._fdhBuilderHost = builderHost;

    function builderForBundle(bundle) {
      if (!bundle) return null;
      return bundle._fdhBuilder || bundle.querySelector('[data-fdh-builder]');
    }

    function notify(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () { toast.classList.remove('is-visible'); }, 2400);
    }

    function activateTab(mode, focus) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.fdhTab === mode;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach(function (panel) {
        var active = panel.dataset.fdhPanel === mode;
        panel.hidden = !active;
        var bundle = panel.matches('[data-fdh-bundle]') ? panel : panel.querySelector('[data-fdh-bundle]');
        var builder = builderForBundle(bundle);
        if (!active && builder) builder.classList.remove('is-visible');
        if (active) {
          window.requestAnimationFrame(function () {
            if (typeof panel._fdhMeasureBuilder === 'function') panel._fdhMeasureBuilder();
            if (typeof panel._fdhUpdateBuilder === 'function') panel._fdhUpdateBuilder();
          });
        }
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        var redirect = tab.dataset.fdhRedirect;
        if (redirect) {
          window.location.assign(redirect);
          return;
        }
        activateTab(tab.dataset.fdhTab, false);
      });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        var next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        tabs[next].focus();
      });
    });
    var initialMode = root.dataset.defaultOffer || 'trial';
    var initialTab = root.querySelector('[data-fdh-tab="' + initialMode + '"]');
    if (initialTab && initialTab.dataset.fdhRedirect) initialMode = 'trial';
    activateTab(initialMode, false);

    var scrollButton = root.querySelector('[data-fdh-scroll-offers]');
    if (scrollButton) scrollButton.addEventListener('click', function () {
      var target = root.querySelector('.fdh-tabs');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    function openGallery(key, title) {
      var dataNode = root.querySelector('[data-fdh-media="' + key + '"]');
      if (!dataNode || !modal || !modalMedia) return;
      var images;
      try { images = JSON.parse(dataNode.textContent); } catch (error) { images = []; }
      if (!images.length) return;
      modalTitle.textContent = title || 'Product gallery';
      modalMedia.innerHTML = '';
      images.forEach(function (image) {
        var img = document.createElement('img');
        img.src = image.src;
        img.alt = image.alt || title || '';
        img.loading = 'lazy';
        modalMedia.appendChild(img);
      });
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var close = modal.querySelector('.fdh-modal__header [data-fdh-close-modal]');
      if (close) close.focus();
    }

    function closeGallery() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    root.querySelectorAll('[data-fdh-open-gallery]').forEach(function (button) {
      button.addEventListener('click', function () {
        var card = button.closest('[data-fdh-product]');
        var title = button.dataset.fdhGalleryTitle || (card ? card.dataset.title : 'Product gallery');
        openGallery(button.dataset.fdhOpenGallery, title);
      });
      if (button.tagName !== 'BUTTON') {
        button.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          var card = button.closest('[data-fdh-product]');
          var title = button.dataset.fdhGalleryTitle || (card ? card.dataset.title : 'Product gallery');
          openGallery(button.dataset.fdhOpenGallery, title);
        });
      }
    });
    root.querySelectorAll('[data-fdh-close-modal]').forEach(function (button) { button.addEventListener('click', closeGallery); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) closeGallery(); });

    function updateCardVariant(card, select) {
      var option = select.options[select.selectedIndex];
      card.dataset.variantId = option.value;
      card.dataset.priceCents = option.dataset.priceCents || '0';
      var price = card.querySelector('[data-fdh-card-price]');
      if (price) price.textContent = money(card.dataset.priceCents);
      var button = card.querySelector('[data-fdh-add-product]');
      var singleButton = card.querySelector('[data-fdh-buy-single]');
      var available = option.dataset.available === 'true';
      var variantImage = option.dataset.image;
      var image = card.querySelector('.fdh-product-card__media img');
      if (variantImage && image) {
        image.src = variantImage;
        image.removeAttribute('srcset');
        card.dataset.image = variantImage;
      }
      button.disabled = !available;
      button.querySelector('[data-fdh-add-label]').textContent = available ? button.dataset.defaultLabel || 'Add' : 'Sold out';
      if (singleButton) singleButton.disabled = !available;
      var bundle = card.closest('[data-fdh-bundle]');
      if (bundle) renderBundle(bundle, false);
    }

    root.querySelectorAll('[data-fdh-product]').forEach(function (card) {
      var add = card.querySelector('[data-fdh-add-product]');
      if (add) add.dataset.defaultLabel = add.querySelector('[data-fdh-add-label]').textContent.trim();
      var select = card.querySelector('[data-fdh-variant-select]');
      if (select) select.addEventListener('change', function () { updateCardVariant(card, select); });
      var singleButton = card.querySelector('[data-fdh-buy-single]');
      if (singleButton) singleButton.addEventListener('click', function () {
        if (singleButton.disabled) return;
        var defaultLabel = singleButton.dataset.defaultLabel || 'Buy single';
        singleButton.disabled = true;
          singleButton.textContent = 'Adding…';
        postItems([{
          id: Number(card.dataset.variantId),
          quantity: 1,
          properties: { '_Fitty offer': 'Single product' }
        }]).then(function () {
          notify('Product added. Opening your cart…');
          return openShopflo();
        }).catch(function (error) {
          notify(error.message);
        }).finally(function () {
          singleButton.disabled = false;
          singleButton.textContent = defaultLabel;
        });
      });
    });

    function stateFor(bundle) { return states[bundle.dataset.mode]; }

    function productCount(state, productId) {
      return state.items.reduce(function (sum, item) { return sum + (item.productId === productId ? 1 : 0); }, 0);
    }

    function productLimitForCard(card) {
      return card && card.dataset.source === 'collection' ? maxSameProduct : 1;
    }

    function renderBundle(bundle, celebrate) {
      var state = stateFor(bundle);
      var limit = Number(bundle.dataset.limit);
      var builder = builderForBundle(bundle);
      if (!builder) return;
      var cartStatus = builder.querySelector('[data-fdh-cart-status]');
      var reset = builder.querySelector('[data-fdh-reset]');
      var slots = Array.prototype.slice.call(builder.querySelectorAll('[data-fdh-slot]'));
      var count = builder.querySelector('[data-fdh-count]');
      var summary = builder.querySelector('[data-fdh-price-summary]');
      var savings = builder.querySelector('[data-fdh-savings]');
      var checkout = builder.querySelector('[data-fdh-checkout]');
      var cards = Array.prototype.slice.call(bundle.querySelectorAll('[data-fdh-product]'));
      var total = state.items.reduce(function (sum, item) { return sum + item.price; }, 0);
      var occurrences = {};

      if (builder) {
        builder.classList.toggle('is-submitted', state.submitted);
        builder.classList.toggle('is-pending', state.pending);
      }
      if (cartStatus) cartStatus.hidden = !state.submitted;
      if (reset) {
        reset.disabled = state.pending || !state.items.length;
        reset.textContent = state.pending ? 'Updating…' : 'Reset';
      }

      slots.forEach(function (slot, index) {
        var item = state.items[index];
        slot.classList.toggle('is-filled', Boolean(item));
        if (item) {
          occurrences[item.productId] = (occurrences[item.productId] || 0) + 1;
          var totalCount = productCount(state, item.productId);
          var quantity = totalCount > 1 ? '<em>x' + occurrences[item.productId] + '</em>' : '';
          slot.innerHTML =
            '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '">' +
            '<strong>' + escapeHtml(item.title) + '</strong>' +
            '<span class="fdh-slot__number">Item ' + (index + 1) + '</span>' +
            quantity +
            '<span class="fdh-slot__remove" aria-hidden="true">Remove</span>';
        } else {
          slot.innerHTML =
            '<span class="fdh-slot__number">Item ' + (index + 1) + '</span>' +
            '<span class="fdh-slot__empty">Add product</span>';
        }
        slot.setAttribute('aria-label', item ? 'Remove ' + item.title : 'Empty item ' + (index + 1));
        slot.disabled = state.pending;
      });

      cards.forEach(function (card) {
        var selectedCount = productCount(state, card.dataset.productId);
        var atLimit = selectedCount >= productLimitForCard(card) || state.items.length >= limit || state.submitted || state.pending;
        card.classList.toggle('is-selected', selectedCount > 0);
        card.classList.toggle('is-at-limit', atLimit);
        var label = card.querySelector('[data-fdh-add-label]');
        var button = card.querySelector('[data-fdh-add-product]');
        if (!button || (button.disabled && label.textContent === 'Sold out')) return;
        button.disabled = atLimit;
        label.textContent = state.pending ? 'Updating…' : state.submitted ? 'In cart' : selectedCount ? 'Added ×' + selectedCount : (button.dataset.defaultLabel || 'Add');
      });

      count.textContent = state.items.length;
      checkout.disabled = state.pending || (!state.submitted && state.items.length !== limit);
      checkout.textContent = state.pending ? 'Adding…' : state.submitted ? 'View cart' : checkout.dataset.defaultLabel;

      if (bundle.dataset.mode === 'any3') {
        var fixed = Number(bundle.dataset.fixedPriceCents) || 0;
        summary.textContent = state.items.length === limit ? 'Bundle total ' + money(fixed) : 'Bundle price ' + money(fixed);
        savings.hidden = !(state.items.length === limit && total > fixed);
        savings.textContent = total > fixed ? 'You save ' + money(total - fixed) : '';
      } else if (state.items.length === limit) {
        var sorted = state.items.map(function (item) { return item.price; }).sort(function (a, b) { return b - a; });
        var estimated = sorted[0] + sorted[1];
        summary.textContent = 'Estimated offer total ' + money(estimated);
        savings.hidden = false;
        savings.textContent = 'Estimated savings ' + money(total - estimated);
      } else {
        summary.textContent = 'Choose four to see estimated offer total';
        savings.hidden = true;
      }

      if (celebrate && state.items.length === limit) {
        builder.classList.remove('is-celebrating');
        void builder.offsetWidth;
        builder.classList.add('is-celebrating');
        window.setTimeout(function () { builder.classList.remove('is-celebrating'); }, 800);
      }
    }

    function escapeHtml(value) {
      var holder = document.createElement('div');
      holder.textContent = value || '';
      return holder.innerHTML;
    }

    root.querySelectorAll('[data-fdh-bundle]').forEach(function (bundle) {
      var state = stateFor(bundle);
      var limit = Number(bundle.dataset.limit);
      var panel = bundle.closest('[data-fdh-panel]');
      var builder = builderForBundle(bundle);
      if (!builder) return;

      bundle._fdhBuilder = builder;
      builder.dataset.fdhBuilderMode = bundle.dataset.mode;
      builderHost.appendChild(builder);

      var checkout = builder.querySelector('[data-fdh-checkout]');
      checkout.dataset.defaultLabel = checkout.textContent.trim();

      function setupBuilderReveal() {
        var products = bundle.querySelector('.fdh-products');
        var revealTarget = products;
        if (!builder || !revealTarget) return;

        function setBuilderVisibility(visible) {
          builder.classList.toggle('is-visible', visible);
          builder.setAttribute('aria-hidden', visible ? 'false' : 'true');
        }

        function measureBuilder() {
          if (panel && panel.hidden) return;
          var height = Math.ceil(builder.getBoundingClientRect().height || builder.offsetHeight || 0);
          if (height) bundle.style.setProperty('--fdh-builder-clearance', (height + 34) + 'px');
        }

        function updateVisibility() {
          if (panel && panel.hidden) {
            setBuilderVisibility(false);
            return;
          }
          var rect = revealTarget.getBoundingClientRect();
          setBuilderVisibility(rect.top < window.innerHeight * .82);
        }

        bundle._fdhUpdateBuilder = updateVisibility;
        bundle._fdhMeasureBuilder = measureBuilder;
        if (panel) {
          panel._fdhUpdateBuilder = updateVisibility;
          panel._fdhMeasureBuilder = measureBuilder;
        }
        setBuilderVisibility(false);
        measureBuilder();

        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (panel && panel.hidden) {
                setBuilderVisibility(false);
                return;
              }
              setBuilderVisibility(entry.isIntersecting || entry.boundingClientRect.top < 0);
            });
          }, {
            rootMargin: '-18% 0px -72% 0px',
            threshold: 0
          });
          observer.observe(revealTarget);
        } else {
          window.addEventListener('scroll', updateVisibility, { passive: true });
        }

        if ('ResizeObserver' in window) {
          var resizeObserver = new ResizeObserver(measureBuilder);
          resizeObserver.observe(builder);
        }
        window.addEventListener('resize', function () {
          measureBuilder();
          updateVisibility();
        });
        window.addEventListener('pageshow', function () {
          measureBuilder();
          updateVisibility();
        });
      }

      setupBuilderReveal();

      function unlockSubmittedBundle() {
        if (!state.submitted || !state.bundleId) return Promise.resolve();
        if (state.pending) return Promise.reject(new Error('Please wait while the bundle is updated.'));

        state.pending = true;
        renderBundle(bundle, false);

        return removeBundleFromCart(state.bundleId).then(function () {
          state.submitted = false;
          state.bundleId = null;
        }).catch(function (error) {
          notify(error.message);
          throw error;
        }).finally(function () {
          state.pending = false;
          renderBundle(bundle, false);
        });
      }

      bundle.querySelectorAll('[data-fdh-add-product]').forEach(function (button) {
        button.addEventListener('click', function () {
          var card = button.closest('[data-fdh-product]');
          if (!card || state.pending) return;
          if (state.submitted) {
            notify('Tap a filled slot or Reset to rearrange this bundle.');
            return;
          }
          if (state.items.length >= limit) { notify('Your offer is already complete.'); return; }
          var productLimit = productLimitForCard(card);
          if (productCount(state, card.dataset.productId) >= productLimit) {
            notify(card.dataset.source === 'collection'
              ? 'You can add this product up to ' + productLimit + ' times.'
              : 'An individually selected product can only be added once.');
            return;
          }
          state.items.push({
            productId: card.dataset.productId,
            variantId: card.dataset.variantId,
            title: card.dataset.title,
            image: card.dataset.image,
            price: Number(card.dataset.priceCents) || 0,
            source: card.dataset.source || 'individual'
          });
          renderBundle(bundle, true);
        });
      });

      builder.querySelectorAll('[data-fdh-slot]').forEach(function (slot) {
        slot.addEventListener('click', function () {
          var index = Number(slot.dataset.fdhSlot);
          if (!state.items[index] || state.pending) return;

          if (state.submitted) {
            unlockSubmittedBundle().then(function () {
              state.items.splice(index, 1);
              renderBundle(bundle, false);
              notify('Product removed. Choose a replacement when ready.');
            }).catch(function () {});
            return;
          }

          state.items.splice(index, 1);
          renderBundle(bundle, false);
        });
      });

      builder.querySelector('[data-fdh-reset]').addEventListener('click', function () {
        if (state.pending || !state.items.length) return;
        if (state.submitted) {
          unlockSubmittedBundle().then(function () {
            state.items = [];
            renderBundle(bundle, false);
            notify('Bundle cleared. You can build a new one.');
          }).catch(function () {});
          return;
        }
        state.items = [];
        renderBundle(bundle, false);
      });

      checkout.addEventListener('click', function () {
        if (state.pending) return;
        if (state.submitted) {
          openShopflo();
          return;
        }
        if (state.items.length !== limit) return;

        state.pending = true;
        renderBundle(bundle, false);
        var bundleId = 'fdh-' + bundle.dataset.mode + '-' + Date.now();
        var grouped = {};
        state.items.forEach(function (item) {
          if (!grouped[item.variantId]) grouped[item.variantId] = 0;
          grouped[item.variantId] += 1;
        });
        var items = Object.keys(grouped).map(function (variantId) {
          return {
            id: Number(variantId),
            quantity: grouped[variantId],
            properties: { '_Fitty offer': bundle.dataset.mode === 'any3' ? 'Any 3 for 2999' : 'Buy 2 Get 2', '_Fitty bundle': bundleId }
          };
        });
        postItems(items).then(function () {
          state.pending = false;
          state.submitted = true;
          state.bundleId = bundleId;
          renderBundle(bundle, false);
          notify('Offer added. Opening your cart…');
          return openShopflo();
        }).catch(function (error) {
          state.pending = false;
          state.submitted = false;
          state.bundleId = null;
          renderBundle(bundle, false);
          notify(error.message);
        });
      });

      renderBundle(bundle, false);
    });

    root.querySelectorAll('[data-fdh-native-gallery]').forEach(function (gallery) {
      var wrap = gallery.closest('.fdh-trial-card__gallery-wrap');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-fdh-trial-slide]'));
      if (!wrap || slides.length < 2) return;

      var previous = wrap.querySelector('[data-fdh-native-prev]');
      var next = wrap.querySelector('[data-fdh-native-next]');
      var counter = wrap.querySelector('[data-fdh-trial-index]');
      var activeIndex = 0;
      var updateFrame;

      function nearestSlideIndex() {
        var left = gallery.scrollLeft;
        var nearestDistance = Infinity;
        var nearestIndex = 0;
        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.offsetLeft - left);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });
        return nearestIndex;
      }

      function updateGalleryUi() {
        activeIndex = nearestSlideIndex();
        if (counter) counter.textContent = (activeIndex + 1) + ' / ' + slides.length;
        if (previous) previous.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === slides.length - 1;
      }

      function scrollToSlide(index) {
        var targetIndex = Math.max(0, Math.min(slides.length - 1, index));
        gallery.scrollTo({ left: slides[targetIndex].offsetLeft, behavior: 'smooth' });
      }

      if (previous) previous.addEventListener('click', function () { scrollToSlide(activeIndex - 1); });
      if (next) next.addEventListener('click', function () { scrollToSlide(activeIndex + 1); });
      gallery.addEventListener('scroll', function () {
        window.cancelAnimationFrame(updateFrame);
        updateFrame = window.requestAnimationFrame(updateGalleryUi);
      }, { passive: true });
      window.addEventListener('resize', updateGalleryUi, { passive: true });
      updateGalleryUi();
    });

    root.querySelectorAll('[data-fdh-trial-card]').forEach(function (card) {
      var select = card.querySelector('[data-fdh-trial-variant]');
      var button = card.querySelector('[data-fdh-trial-add]');
      if (select) select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        card.dataset.variantId = option.value;
        card.dataset.priceCents = option.dataset.priceCents;
        card.querySelector('[data-fdh-trial-price]').textContent = money(option.dataset.priceCents);
        var compare = card.querySelector('[data-fdh-trial-compare]');
        var compareCents = Number(option.dataset.compareAtCents) || 0;
        if (compare) {
          compare.textContent = money(compareCents);
          compare.hidden = compareCents <= Number(option.dataset.priceCents);
        }
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Sold out' : button.dataset.defaultLabel;
      });
      button.dataset.defaultLabel = button.textContent.trim();
      button.addEventListener('click', function () {
        if (button.disabled) return;
        button.disabled = true;
        button.textContent = 'Adding…';
        postItems([{ id: Number(card.dataset.variantId), quantity: 1, properties: { '_Fitty offer': '15-Day Trial' } }])
          .then(openShopflo)
          .catch(function (error) { notify(error.message); })
          .finally(function () { button.disabled = false; button.textContent = button.dataset.defaultLabel; });
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-fdh-root]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches && event.target.matches('[data-fdh-root]')
      ? event.target
      : event.target.querySelector('[data-fdh-root]');
    if (root && root._fdhBuilderHost) root._fdhBuilderHost.remove();
  });
}());
